var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24.6706,
    cy: 23.8782,
    r: 22.2447,
    transform: "rotate(-90 24.6706 23.8782)",
    stroke: "black",
    strokeWidth: 3.05489
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.8682 33.1511V24.3607H28.2948L28.6163 21.3314H25.8682L25.8723 19.8153C25.8723 19.0252 25.9474 18.6018 27.0822 18.6018H28.5991V15.5723H26.1723C23.2572 15.5723 22.2311 17.0418 22.2311 19.513V21.3318H20.4141V24.361H22.2311V33.1511H25.8682Z",
    fill: "#0A0A0A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.fc2e242e.svg";
export { ForwardRef as ReactComponent };